import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { useGetPayoutsSummaryV1Query } from '../../../hooks/use-payouts-list';
import { Card } from '../../Card/card';
import { SummaryItem } from '../../SummaryItem';

export const summaryCard = css`
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: ${theme.spacing(2, 4)};
  box-shadow: unset;
  border: solid 1px ${theme.colors.neutral20};
`;

export const PayoutsSummary = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  const payoutsSummary = useGetPayoutsSummaryV1Query({ locationIds });
  const { t } = useTranslation('payments');

  return (
    <Card radius='medium' shadow='heavy' css={summaryCard}>
      <SummaryItem
        label={t('Total Balance')}
        amount={payoutsSummary.data?.totalBalance}
        loading={payoutsSummary.isLoading}
      />
      <SummaryItem
        label={t('Estimated Future Payouts')}
        amount={payoutsSummary.data?.estimatedFuturePayouts}
        loading={payoutsSummary.isLoading}
      />
      <SummaryItem
        label={t('In Transit to Bank')}
        amount={payoutsSummary.data?.inTransitToBank}
        loading={payoutsSummary.isLoading}
      />
    </Card>
  );
};
